module.exports = __webpack_public_path__ + "static/media/contact.52eb7f66.jpg";